module.exports = __webpack_public_path__ + "img/top01.b6af0e26.png";